<script lang="ts" setup>
  import type { Song } from '../../../../shared/api/song.ts';
  import Suggestion from './SuggestionRow.vue';

  defineProps<{
    songs: Song[];
  }>();

  defineEmits<{
    (e: 'songSelected', song: Song): void;
  }>();
</script>

<template>
  <div class="suggestion-list" tabindex="0">
    <Suggestion v-for="song in songs" :key="song.id" :song="song" @click="$emit('songSelected', song)" />
  </div>
</template>

<style scoped>
  .suggestion-list {
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-control);
    box-shadow: 0 10px 25px var(--color-shadow);
    display: flex;
    flex-direction: column;
    max-height: 100%;
    overflow-y: auto;
    scrollbar-color: var(--color-primary) transparent;
    scrollbar-width: thin;
    width: 100%;
  }

  .suggestion-list::-webkit-scrollbar {
    width: 6px;
  }

  .suggestion-list::-webkit-scrollbar-track {
    background: transparent;
  }

  .suggestion-list::-webkit-scrollbar-thumb {
    background: var(--color-primary);
    border-radius: var(--radius-control);
  }

  .suggestion-list::-webkit-scrollbar-thumb:hover {
    background: color-mix(in srgb, var(--color-primary), var(--color-shade) 10%);
  }
</style>
